<template>
    <button
        :aria-expanded="isNavOpen"
        aria-label="Main menu"
        class="size-8 cursor-pointer legacy-md:hidden"
        type="button"
    >
        <img
            alt=""
            src="@/assets/svg/unified-menu.svg"
        />
    </button>
</template>

<script setup lang="ts">
defineProps<{ isNavOpen: boolean }>();
</script>
